import decode from 'jwt-decode';

/**
 * get a complete name and return just the first and the last name
 * @param {string} name
 */
export function getNameResume(name) {
  if (!name) return;

  const names = name.split(' ');

  if (names.length === 1) return name;

  return `${names[0]} ${names[names.length - 1]}`;
}

export function getNomeUsuarioAlternado(nomeAlternado) {
  if (!nomeAlternado) return;

  const names = nomeAlternado.split(' ');

  if (names.length === 1) return nomeAlternado;

  return `${names[0]} ${names[names.length - 1]}`;
}

export function getInitialLettersUser(name) {
  if (!name) return;

  const arrayNameString = name.split(' ');

  if (arrayNameString.length === 1) {
    return `${arrayNameString[0].substring(0, 1)}`;
  }

  if (arrayNameString.length >= 2) {
    return `${arrayNameString[0].substring(0, 1)}${arrayNameString[1].substring(
      0,
      1
    )}`;
  }
}

export const comboPerfil = [
  { id: 'SOTRAN', desc: 'Sotran' },
  { id: 'CLIENTE', desc: 'Cliente' },
];

/**
 * Pegar estados permitidos
 */
export const getEstadosPermitidos = () => {
  const token = localStorage.getItem('access_token');
  return decode(token).user.controle_embarque_estados_permitidos.split(',');
};
